import { render, staticRenderFns } from "./normativas.vue?vue&type=template&id=e7bb5b08&scoped=true"
import script from "./normativas.ts?vue&type=script&lang=ts&external"
export * from "./normativas.ts?vue&type=script&lang=ts&external"
import style0 from "./normativas.vue?vue&type=style&index=0&id=e7bb5b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bb5b08",
  null
  
)

export default component.exports